import { defaultButton, defaultId, defaultStyle, defaultTime, defaultDate } from "./shared.js";

// Custom functions for table columns.
const clickButton = (props, params) => {
    props.browser.navigate(`/database/patients/${params.row.id}`);
};

// Column definitions.
const patientIdentifier = {
    ...defaultStyle,
    field: "patient_identifier",
    headerName: "Patient ID",
    flex: 0.15,
    minWidth: 90,
    valueGetter: (params) => params.row.patient_identifier ?? "N/A"
};
const firstName = {
    ...defaultStyle,
    field: "first_name",
    headerName: "First Name",
    flex: 0.2,
    minWidth: 100,
    valueGetter: (params) => params.row.first_name ?? "N/A"
};
const lastName = {
    ...defaultStyle,
    field: "last_name",
    headerName: "Last Name",
    flex: 0.2,
    minWidth: 100,
    valueGetter: (params) => params.row.last_name ?? "N/A"
};
const birthDate = {
    ...defaultDate("birth_date"),
    field: "birth_date",
    headerName: "Birth Date",
    flex: 0.15,
    minWidth: 100
};
const examinationCount = {
    ...defaultStyle,
    field: "examination_count",
    headerName: "Examinations",
    flex: 0.12,
    minWidth: 100,
    sortable: false,
    filterable: false,
    valueGetter: (params) => params.row.examinations?.length ?? 0
};
const notes = { ...defaultStyle, field: "notes", headerName: "Notes", flex: 0.25, minWidth: 200 };
const createdOn = { ...defaultTime("created_on"), headerName: "Created on" };
const updatedOn = { ...defaultTime("updated_on"), headerName: "Updated on" };
const action = (props) => {
    return { ...defaultButton(props, { onClick: clickButton, title: "View" }), minWidth: 100, flex: 0.1 };
};

// Table columns.
export const columns = (props) => [patientIdentifier, defaultId, firstName, lastName, birthDate, examinationCount, notes, createdOn, updatedOn, action(props)];

// Style and other misc. functions.
export const isRowSelectable = (props, params) => {
    return true;
};

// Default aggregate props of the table.
export const defaultTableOptions = {
    isRowSelectable,
    checkboxSelection: true
};
